import { render, staticRenderFns } from "./DashboardCommsTrio.vue?vue&type=template&id=501df1c8&scoped=true&"
import script from "./DashboardCommsTrio.vue?vue&type=script&lang=js&"
export * from "./DashboardCommsTrio.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCommsTrio.vue?vue&type=style&index=0&id=501df1c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501df1c8",
  null
  
)

export default component.exports